import { Required, Schema, TextField } from "lego-gui-lib/lib";
import { ContextAwareListDataSource } from "../../../common/ContextAwareListDataSource";
import { mainStore, api } from "../../../core/mainStore";
import { t } from "../../../core/i18n/i18n";
import { ForeignKeyField } from "lego-gui-lib";
import { Auth } from "../../../core/model/auth";
import { AreaSplittingFK } from "../schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { queryParamDtoStrategy } from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";
import { LabelFieldOption, withExternalId } from "../../../common/common";

export const GroupSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    },
    {
      name: "areaSplittingRef",
      type: AreaSplittingFK,
      title: t("hns:areaSplitting:domain")
    }
  ]
});

export const EditGroupSchema = GroupSchema.extend({
  areaSplittingRef: false
});

mainStore.areaSplittingGroup = RemoteChildDataSource.create({
  api: api,
  parent: mainStore.areaSplitting.oneDataSource,
  dtoStrategy: queryParamDtoStrategy("id", "areaSplittingRef"),
  name: "areaSplittingGroup",
  schema: GroupSchema,
  url: "/groups",
  commons: mainStore.commons
});

mainStore.AreaSplittingGroupFk = RemoteChildDataSource.clone(
  mainStore.areaSplittingGroup
);

export const AreaSplittingGroupFK = ForeignKeyField(
  {
    dataSource: mainStore.AreaSplittingGroupFk,
    labelField: withExternalId(),
    searchField: "name",
    valueField: "id"
  },
  Required
);

mainStore.areaSplittingGroupForTree = new ContextAwareListDataSource({
  api: api,
  name: "areaSplittingGroup",
  schema: GroupSchema,
  url: "/areaGroups",
  commons: mainStore.commons,
  observableFieldRef: "customerRef",
  observableDataSource: "customer"
});

export const AreaSplittingGroupForTreeFK = ForeignKeyField(
  {
    dataSource: mainStore.areaSplittingGroupForTree,
    labelField: (option: LabelFieldOption) => {
      const externalId = option.customerExternalId;
      const name = option.name;
      const areaSplittingName = option.areaSplittingName;

      const visibility = externalId
        ? `[${t("common:private")()}]`
        : `[${t("common:public")()}]`;

      return `${areaSplittingName} - ${name} ${visibility}`;
    },
    searchField: "areaSplittingName",
    valueField: "id"
  },
  Required
);
